export default __webpack_public_path__ + "static/cloud-threat-hunting-c0f69c5d1e826f2cdb567d033e280473.png";